export enum ErrorType {
    NOTALLOWEDERROR = 'NotAllowedError',
    NOTFOUNDERROR = 'NotFoundError'
}